import { render, staticRenderFns } from "./BlotterView.vue?vue&type=template&id=f48dab52&scoped=true"
import script from "./BlotterView.vue?vue&type=script&lang=js"
export * from "./BlotterView.vue?vue&type=script&lang=js"
import style0 from "./BlotterView.vue?vue&type=style&index=0&id=f48dab52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48dab52",
  null
  
)

export default component.exports